import type { z } from 'zod';
import { nameField } from '../schemas/name-field';
import { shortTextField } from '../schemas/short-text-field';
import { zs } from '../schemas/zod';

/** A file referenced by a record, stored by the sha256 of its bytes on every device. */
export const attachmentSchema = zs.object({
  sha256: zs.string().regex(/^[0-9a-f]{64}$/),
  name: nameField,
  type: shortTextField.default('application/octet-stream'),
  size: zs.number().int().min(0),
});

export type Attachment = z.infer<typeof attachmentSchema>;
